import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CONSTANTS } from '../../data';

interface StoryChapterModalProps {
  currentChapter: {id: string, title: string, text: string} | null;
  onClose: () => void;
}

export const StoryChapterModal: React.FC<StoryChapterModalProps> = ({
  currentChapter,
  onClose
}) => {
  return (
    <AnimatePresence>
      {currentChapter && (
        <motion.div
          className="chapter-overlay"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: CONSTANTS.STORY_CHAPTERS.fadeInDuration / 1000 }}
        >
          <motion.div
            className="chapter-modal"
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.8, opacity: 0 }}
            transition={{ type: 'spring', stiffness: 300, damping: 30 }}
          >
            <div className="chapter-header">
              <h2 className="chapter-title">{currentChapter.title}</h2>
            </div>
            <div className="chapter-content">
              <p className="chapter-text">{currentChapter.text}</p>
            </div>
            <button
              className="chapter-continue-btn"
              onClick={onClose}
            >
              Continue
            </button>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
